export function beforePageUnload (event) {
  if (!window.confirm('Are you sure you want to leave this page? Changes you made may not be saved.')) {
    event.preventDefault()

    if (event.type === 'beforeunload') {
      event.returnValue = true
    }
  }
}
